import styled from 'styled-components';

export const CardView = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;
